import React, {Suspense, useContext} from "react";
import "./twitter.scss";
import Loading from "../loading/Loading";
import {twitterDetails} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

const renderLoader = () => <Loading />;

export default function Twitter() {
  useContext(StyleContext);

  if (!twitterDetails.display) {
    return null;
  }

  return (
    <Suspense fallback={renderLoader()}>
      <div className="main" id="twitter">
        <div className="twitter-main-div">
          {/* Placeholder text karena library dihapus */}
          <h3 style={{textAlign: "center", marginTop: "20px"}}>
            Twitter Feed Unavailable
          </h3>
        </div>
      </div>
    </Suspense>
  );
}
